export default __webpack_public_path__ + "static/ai-marketing-5--mobile-9b8c75e5052b82ad9a9463e5562f7ad5.webp";